import { render, staticRenderFns } from "./Adopted.vue?vue&type=template&id=28f13192&"
import script from "./Adopted.vue?vue&type=script&lang=js&"
export * from "./Adopted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports